<span class="data-label font-size-14px" [ngClass]="fontSize">Directions: </span>
<span class="data-value font-size-14px" [ngClass]="fontSize"
    >You are about to take the activity, "<span class="directions-bolded">{{
        assignment.assignmentName
    }}</span
    >". You will have
    <span class="font-weight-600">{{ asset.mediaTime }}</span>
    seconds to view a stimulus. You can watch it<span class="font-weight-600">{{
        formatMaxAttempts(assignment.maxAttempts)
    }}</span
    >. Then, you will have
    <span class="font-weight-600">{{ asset.recordTime }}</span>
    seconds to record your response. You have
    <span class="font-weight-600">{{ maxAttempts }}</span>
    to record. Finally, you will rate your performance.
</span>
